export default {
  appBarHeight: "64px",
  drawerWidth: "256px",
  drawerWidthNumeric: 256,
  mainContentMarginBottom: "5px",
  mainContentMarginLeft: 0,
  mainContentMarginRight: "5px",
  mainContentMarginTop: 0,
};
